export const container = `
  m-0 mb-2
  data-[nomargin=true]:mb-0
  data-[align=left]:text-left
  data-[align=center]:text-center
  data-[align=right]:text-right
  data-[variant=h1]:text-ll-font-size-h1
  data-[variant=h2]:text-ll-font-size-h2
  data-[variant=h3]:text-ll-font-size-h3
  data-[variant=h4]:text-ll-font-size-h4
  data-[variant=h5]:text-ll-font-size-h5
  data-[variant=h6]:text-ll-font-size-h6
  data-[variant=p]:text-ll-font-size-p
  data-[variant=caption1]:text-ll-font-size-caption-1
  data-[variant=caption2]:text-ll-font-size-caption-2
  data-[texttransform=capitalize]:capitalize
  data-[texttransform=uppercase]:uppercase
  data-[texttransform=lowercase]:lowercase
  data-[texttransform=none]:normal-case
  data-[family=sans-serif]:font-sans
  data-[family=mono]:font-mono

  data-[lineclamp=none]:line-clamp-none
  data-[lineclamp=none]:whitespace-nowrap
  data-[lineclamp="1"]:line-clamp-1
  data-[lineclamp="2"]:line-clamp-2
  data-[lineclamp="3"]:line-clamp-3
  data-[lineclamp="4"]:line-clamp-4
  data-[lineclamp="5"]:line-clamp-5
  data-[lineclamp="6"]:line-clamp-g
`;
